<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <div class="nav">
      <div class="module-title">
        <h1>医学影像中心VR系统</h1>
      </div>

      <div class="ct-content">
        <div class="single-col-card">
          <!-- 顶部文字描述（标准左侧蓝竖线样式） -->
          <div class="text-wrap">
            <p class="text-content">{{ p[0] }}</p>
          </div>

          <!-- 全景大图（文字在上，图片在下垂直布局，移除左右分栏） -->
          <div class="main-banner hero-image">
            <img
              :src="img[0]"
              alt="医学影像中心VR系统，虚拟三甲影像中心，DR CT MRI沉浸式虚拟实训平台"
              class="banner-img"
              loading="lazy"
              decoding="async"
            />
            <div class="banner-glow img-mask"></div>
          </div>

          <!-- 缩略图网格 -->
          <el-row :gutter="16" class="thumb-grid" type="flex" style="flex-wrap: wrap">
            <el-col
              :xs="12"
              :sm="12"
              :md="8"
              :lg="6"
              v-for="item in img.slice(1)"
              :key="item"
              style="margin-bottom: 16px"
            >
              <div class="imgSeg">
                <img
                  :src="item"
                  alt="医学影像中心VR场景效果图"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </el-col>
          </el-row>

          <!-- 软件功能介绍 -->
          <div class="software main-flex">
            <h2>软件功能介绍</h2>
            <div class="intro main-flex">
              <p v-for="(item, index) in p.slice(1)" :key="index" class="text-content">{{ item }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PullDown from "@/components/home/pullDown.vue"
export default {
  props: {
    hidePullDown: {
      type: Boolean,
      default: false // 默认显示
    }
  },
  name: "VRImagingCenter",
  components: {
    PullDown
  },
  data() {
    return {
      wWidth: window.innerWidth,
      p: [
        "本系统深度契合高校医学影像人才培养需求，以《医学影像学导论》为理论蓝本，采集三甲综合医院的真实场景数据，建设四层虚拟仿真医学影像中心，配置DR、CT、MRI等9种大型医学影像设备，设计20个教学场景，构建专业知识和思政教育的情景化教学平台。知识点模块化设计，可根据教学目标进行实验课程内容组合，满足不同专业和学制阶段的培养要求。本系统荣获2025世界VR产业大会优秀创新成果奖，学生足不出校即可沉浸式认知影像中心全貌与设备布局，为临床实习打下坚实基础。",
        "该VR软件系统按照三甲医院要求，三维重建医学影像中心虚拟场景；",
        "根据医院实景，构建常规大型设备MRI、CT、DR、胃肠机、乳腺机、口腔机以及诊断报告室、PACS室、胶片打印室等；",
        "具有可拓展性，预留B超、DSA、ECT、PET、PET-CT、PET-MR、直线加速器等模块；",
        "通过VR设备，第一人称视角实现场景内完全自由漫游，360°环视场景，可以进行设备操作、患者检查体验；",
        "通过VR操作训练，让学习者对医院医学影像中心布局及设备功能有真实体验理解。"
      ],
      img: [
        require("@/assets/vr_big.png"),
        require("@/assets/vr1.png"),
        require("@/assets/vr2.png"),
        require("@/assets/vr3.png"),
        require("@/assets/vr4.png"),
        require("@/assets/vr5.png"),
        require("@/assets/vr6.png"),
        require("@/assets/vr7.png"),
        require("@/assets/vr8.png")
      ]
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    h1 {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
    }

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 48px;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
      gap: 36px;
    }
    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
      gap: 28px;
    }
  }

  .single-col-card {
    background: #fff;
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    margin: auto;
  }

  // 全局统一标准文字样式（全系列页面共用）
  .text-content {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 0.95rem;
    line-height: 2;
    color: #1e293b;
    text-align: justify;
    letter-spacing: 0.01em;
    position: relative;
    padding-left: 1rem;
    border-left: 3px solid transparent;

    @media (max-width: 767px) {
      font-size: 0.85rem;
      line-height: 1.85;
      padding-left: 0.75rem;
    }

    &:first-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }

    &:last-of-type {
      margin-bottom: 0;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }
  }

  // ========== 全景大图区域（垂直布局，移除左右分栏） ==========
  .hero-image.main-banner {
    width: 100%;
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 20px 50px rgba(26, 127, 196, 0.18);
    position: relative;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

    .banner-img {
      width: 100%;
      height: auto;
      display: block;
      transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .img-mask {
      position: absolute;
      inset: 0;
      background: linear-gradient(135deg, rgba(26, 127, 196, 0.08) 0%, transparent 50%);
      pointer-events: none;
    }
    .banner-glow {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 45%;
      background: linear-gradient(to top, rgba(26, 75, 140, 0.22), transparent);
      pointer-events: none;
    }

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 24px 60px rgba(26, 127, 196, 0.22);
      .banner-img {
        transform: scale(1.04);
      }
    }
  }

  // ========== 缩略图网格 ==========
  .thumb-grid {
    margin-bottom: 0;
  }
  .imgSeg {
    aspect-ratio: 16 / 10;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(26, 127, 196, 0.08);
    background: #fff;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    img {
      width: 100%;
      height: 100%;
      display: block;
      transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    }
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 16px;
      border: 2px solid transparent;
      transition: all 0.3s ease;
      pointer-events: none;
    }
    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 10px 30px rgba(26, 127, 196, 0.12);
      img {
        transform: scale(1.08);
      }
      &::after {
        border-color: rgba(26, 127, 196, 0.4);
      }
    }
  }

  // ========== 软件功能介绍 ==========
  .software {
    border-radius: 24px;
    background: #ffffff;
    box-shadow: 0 10px 30px rgba(26, 127, 196, 0.12);
    overflow: hidden;
    position: relative;
    border: none;
    display: flex;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(135deg, #2563af 0%, #4facfe 100%);
      z-index: 2;
    }
    h2 {
      font-size: 28px;
      margin: 0;
      letter-spacing: 6px;
      padding: 32px 20px;
      font-weight: 700;
      writing-mode: vertical-lr;
      color: #fff;
      background: linear-gradient(135deg, #2563af 0%, #4facfe 100%);
      border-radius: 0;
      min-height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 4px 0 16px rgba(26, 127, 196, 0.15);
    }
    .intro {
      font-size: 16px;
      flex-direction: column;
      margin-left: 36px;
      margin-right: 24px;
      line-height: 2.2;
      padding: 20px 0;
      display: flex;
      gap: 12px;
    }
  }

  // ========== 移动端适配 ==========
  @media only screen and (max-width: 767px) {
    .software {
      flex-direction: column;
      border-radius: 16px;
      padding: 0 0 20px 0;
      h2 {
        font-size: 20px;
        letter-spacing: 4px;
        writing-mode: horizontal-tb;
        padding: 20px 16px;
        min-height: auto;
        width: 100%;
        box-shadow: none;
      }
      .intro {
        margin-left: 16px;
        margin-right: 16px;
        padding-top: 8px;
        font-size: 15px;
      }
    }
    .main-flex {
      flex-direction: column;
    }
  }
}

// 暗色模式完整适配（全系列页面统一）
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .single-col-card {
          background: #142033;
        }
        .text-content {
          color: #c8d6e8;
          &:first-of-type {
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
          }
          &:last-of-type {
            background: linear-gradient(90deg, rgba(139, 92, 246, 0.08) 0%, transparent 100%);
          }
        }
        .software {
          background: #142033;
          h2 {
            background: linear-gradient(135deg, #1d4ed8, #60a5fa);
          }
        }
        .imgSeg {
          background: #142033;
        }
      }
    }
  }
}

// 全局导航统一穿透样式
:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}
</style>